import axios from "axios";
import {
    COUPON_LIST_REQUEST,
    COUPON_LIST_SUCCESS,
    COUPON_LIST_FAIL,
    COUPON_DETAILS_REQUEST,
    COUPON_DETAILS_SUCCESS,
    COUPON_DETAILS_FAIL

} from "../constants/categoryConstants";
import { BASE_URL, COUPON_URL } from "../api";




export const listCoupon = () => async (dispatch) => {
  try {
    dispatch({ type: COUPON_LIST_REQUEST });
    const { data } = await axios.get(BASE_URL+COUPON_URL);
    // window.print('Anjani'),
    dispatch({
      type: COUPON_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: COUPON_LIST_FAIL,
      
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};


export const listCouponDetails =(id) => async (dispatch)=>{
  try{
      dispatch({type:COUPON_DETAILS_REQUEST})
      const {data} = await axios.get(`/api/products/${id}`)
      dispatch({
          type:COUPON_DETAILS_SUCCESS,
          payload:data
      })
  }
  catch(error){
      dispatch({
          type:COUPON_DETAILS_FAIL,
          payload:error.response && error.response.data.detail
          ? error.response.data.detail
          :error.message,
      })

  }
}